import React from 'react'
import Select from 'react-select'

const UrlsDropdownFilter = props => {
  const options = [
    { label: 'All', value: 'All' },
    { label: 'Listing approved', value: 'Listing approved' },
    { label: 'Listing created and under review', value: 'Listing created and under review' },
    { label: 'Listing under creation', value: 'Listing under creation' },
    { label: 'Cancelled', value: 'Cancelled' },
    { label: 'Rejected', value: 'Rejected' }
  ]

  const customStyles = {
    container: (base) => ({
      ...base,
      minWidth: '200px'
    }),
    control: (base, state) => ({
      ...base,
      boxShadow: state.isFocused ? 0 : 0,
      borderColor: '#AAAAAA',
      width: '100%',
      ':hover': {
        borderColor: '#AAAAAA'
      }
    }),
    menu: (base) => ({
      ...base,
      minWidth: '200px'
    }),
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? 'lightgray' : 'white',
        color: isSelected ? 'black' : 'inherit',
        ':active': {
          backgroundColor: 'lightgray',
          color: 'black'
        },
        ':hover': {
          backgroundColor: '#F3F3F3',
          color: 'black'
        }
      }
    }
  }

  return (
    <Select
      options={options}
      onChange={props.onChange}
      value={props.selected}
      defaultValue={options[0]}
      styles={customStyles}
    />
  )
}

export default UrlsDropdownFilter
